export const environment = {
  production: false,
  baseUrl: 'https://cloud-int.rainmesh.de',
  backendApiUrl: 'api-int.rainmesh.de',
  protocolBackend: 'https://',
  websocketProtocolBackend: 'wss://',
  contextPathBackend: '/rest/v1',
  sso: {
    ssoBaseUrl: 'https://sso.rainmesh.letsdev.de',
    ssoRequireHttps: false,
    clientId: 'rainmesh-web',
    apiUrl: 'https://api-int.rainmesh.de',
    baseUrl: 'https://cloud-int.rainmesh.de',
    allowedUrls: ['https://api-int.rainmesh.de'],
    scope: 'openid api:read api:write api:delete profile email',
  }
};
